import { BusinessStreams } from '@cambridgeassessment/ciam-commons';
import AppleLogo from 'src/assets/img/social_icons/Apple.svg';
import FacebookLogo from 'src/assets/img/social_icons/Facebook.svg';
import GoogleLogo from 'src/assets/img/social_icons/Google.svg';
import MicrosoftLogo from 'src/assets/img/social_icons/Microsoft.svg';
import { OrgUserStatus } from './types';

export const SOCIAL_ICONS = {
  Apple: AppleLogo,
  Facebook: FacebookLogo,
  Google: GoogleLogo,
  Microsoft: MicrosoftLogo,
};

export const PASSWORD_RULES = {
  length: 8,
  letters: 1,
  numbers: 1,
};

export const SOC_USER_PASSWORD_SUMMARY =
  'You have signed in with a social network provider. Once you have a new password created,  you will be able to sign in using either social network or your email.';

export const NOTIFICATION_DELAY_MS = 420000;

export const businessUnits = [
  BusinessStreams.ENGLISH,
  BusinessStreams.INTERNATIONAL,
  BusinessStreams.OCR,
];

export const DEFAULT_PERSONAL_INFO_FORM_SUCCESS_MESSAGE =
  'Personal details were updated.';

export const DEFAULT_ERROR_MESSAGE =
  'Sorry. We encountered an unexpected problem. Try again later or contact support team.';

export const EMAIL_GDPR = 'privacy@cambridge.org?subject=GDPR Enquiry';

export const ALL_PLATFORMS = 'Centre Administration';
export const GLOBAL_LISTENING = 'Global Listening';
export const GLOBAL_LISTENING_EXTERNAL = 'Global Listening External Portal';
export const GLOBAL_LISTENING_INTERNAL = 'Global Listening Internal Portal';

export const platforms = [
  'Centre Administration',
  'Access to Scripts External',
  'Global Listening',
  'Submit for Assessment External',
]; // contains updated title for platform

export const MAX_FILE_UPLOAD_SIZE = 6291456; //1MB = 1048576. Hence, 6MB = 1048576 * 6

export const SOCIAL_LINKS = {
  facebook: 'https://www.facebook.com/CambPressAssess',
  instagram: 'https://www.instagram.com/cambpressassess',
  linkedin:
    'https://www.linkedin.com/company/cambridge-university-press-and-assessment/',
  twitter: 'https://twitter.com/CambPressAssess',
  youtube: 'https://www.youtube.com/channel/UCNnk0pi7n4Amd_2afMUoKGw',
};

export const MIN_COUNT_TO_SHOW_SEARCHBAR = 9;

export const ORG_USER_STATUS = {
  ACTIVE: OrgUserStatus.Active,
  INACTIVE: OrgUserStatus.Inactive,
  REGISTERED: OrgUserStatus.Registered,
  INVITED: OrgUserStatus.Invited,
};

export const HOTJAR_VERSION = 6;

export const enum Roles {
  REPORT_MAKER_EXAM_OFFICER = 'REPORT_MAKER_EXAMS_OFFICER',
  REPORT_MAKER_HEAD_OF_CENTRE = 'REPORT_MAKER_HEAD_OF_CENTRE',
  REPORT_MAKER_TEACHER = 'REPORT_MAKER_TEACHER',
  SCHOOL_SUPPORT_HUB_TEACHER = 'SCHOOL_SUPPORT_HUB_TEACHER',
  SCHOOL_SUPPORT_HUB_ADMIN = 'SCHOOL_SUPPORT_HUB_ADMIN',
  SCHOOL_SUPPORT_HUB_COORDINATOR = 'SCHOOL_SUPPORT_HUB_COORDINATOR',
}

export const REPORT_MAKER_ROLES = [
  Roles.REPORT_MAKER_EXAM_OFFICER,
  Roles.REPORT_MAKER_HEAD_OF_CENTRE,
  Roles.REPORT_MAKER_TEACHER,
];

export const SCHOOL_SUPPORT_HUB_ROLES: string[] = [
  Roles.SCHOOL_SUPPORT_HUB_ADMIN,
  Roles.SCHOOL_SUPPORT_HUB_COORDINATOR,
];

export const COUNTRY_CODE_US = 'US';

export const INTERNAL_DOMAINS = [
  'cambridgeassessment.org.uk',
  'cambridge.org',
  'ocr.org.uk',
  'cambridgeenglish.org',
  'cambridgeesol.org',
  'cambridgeassessment.org',
  'ucles.org',
  'ucles.cam.ac.uk',
  'ucles.org.uk',
  'cambridgeorg.onmicrosoft.com',
  'cambridgeinternational.org',
  'cie.org.uk',
];

export const GLCI_ROLES = [
  'GLCI_CONFIDENTIAL_ADMIN',
  'GLCI_CONFIDENTIAL_EXAMS_OFFICER',
];

export const HIDDEN_PLATFORMS_IN_PROD = ['RM Assessment Master'];

export const HIDDEN_ROLES_IN_PROD = {
  ['Access to Scripts']: ['ACCESS_TO_SCRIPTS'],
  ['RM Assessment Master']: [
    'RMAM_CENTRE_ADMIN_MOCK_EXAMS',
    'RMAM_CENTRE_ADMIN_LIVE_EXAMS',
  ],
};
